import React, { lazy, Suspense, useEffect, useState } from 'react';
import Navbar from './components/navbar';
import Footer from './components/footer';
import LoadingGif from './components/loading-gif';
import logo from './images/hero/logo.avif';
// import LTC from './components/competition';
import { Routes, Route, useLocation } from 'react-router-dom';

const Home = lazy(() => import('./pages/Home'));
const Karl = lazy(() => import('./pages/Karl'));
const Crissy = lazy(() => import('./pages/Crissy'));
const Mark = lazy(() => import('./pages/Mark'));
const Contact = lazy(() => import('./pages/Contact'));

function App() {
  const location = useLocation();
  const [showIntro, setShowIntro] = useState(false);

  useEffect(() => {
    const introSeenKey = 'darkside_intro_seen';
    const hasSeenIntro = sessionStorage.getItem(introSeenKey);
    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;

    if (!hasSeenIntro && !reduceMotion) {
      setShowIntro(true);
      sessionStorage.setItem(introSeenKey, 'true');

      const timer = window.setTimeout(() => {
        setShowIntro(false);
      }, 2000);

      return () => window.clearTimeout(timer);
    }

    return undefined;
  }, []);

  useEffect(() => {
    document.body.style.overflow = showIntro ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [showIntro]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.classList.remove('fslightbox-open');
    if (document.body) {
      if (!showIntro) {
        document.body.style.overflow = '';
      }
      document.body.style.paddingRight = '';
    }
  }, [location.key, showIntro]);

  return (
    <>
      {showIntro ? (
        <div className='intro-cinematic' aria-hidden='true'>
          <div className='intro-cinematic__smoke'>
            <span className='intro-cinematic__plume intro-cinematic__plume--one' />
            <span className='intro-cinematic__plume intro-cinematic__plume--two' />
            <span className='intro-cinematic__plume intro-cinematic__plume--three' />
          </div>
          <img
            src={logo}
            alt=''
            className='intro-cinematic__logo'
            aria-hidden='true'
          />
        </div>
      ) : null}
      <Navbar />
      {/* <LTC /> */}
      <Suspense
        fallback={
          <div className='min-h-[40vh] flex items-center justify-center px-4'>
            <LoadingGif label='Loading portfolio...' onDark />
          </div>
        }
      >
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/karl' element={<Karl />} />
          <Route path='/crissy' element={<Crissy />} />
          <Route path='/mark' element={<Mark />} />
          <Route path='/contact' element={<Contact />} />
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
}

export default App;
